import React from 'react'

export default function Divider({ className = '' }) {
  return (
    <hr className={`mx-auto mt-6 w-10 border-b border-gray-400 ${className}`} />
  )
}
